"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const useDevice_1 = require("../../hooks/useDevice");
const colors_1 = require("../../common/colors");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const BigButton_1 = __importDefault(require("../GradientButton/BigButton"));
const native_base_1 = require("native-base");
const AppText_1 = require("../AppText");
const GenericModal = ({ isOpen, onClose, onSubmit, modalTitle = "Update", initialValue = "", placeholderText = "Enter value", submitButtonText = "Submit" }) => {
    const { isWebDevice, isMobileScreen } = (0, useDevice_1.useDevice)();
    const [inputValue, setInputValue] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        if (!isOpen) {
            setInputValue('');
        }
        else {
            setInputValue(initialValue);
        }
    }, [isOpen, initialValue]);
    const isSubmitDisabled = inputValue.trim().length === 0;
    const moveAnimation = (0, react_1.useRef)(new react_native_1.Animated.Value(0)).current;
    const handleSubmit = () => {
        onSubmit(inputValue);
        onClose();
    };
    const isMacOSSafariWebView = /Macintosh.*AppleWebKit(?!.*Safari)/.test(navigator.userAgent);
    const handleInputFocus = () => {
        if (!isMacOSSafariWebView) {
            react_native_1.Animated.timing(moveAnimation, {
                toValue: -148,
                duration: 300,
                useNativeDriver: true,
            }).start();
        }
    };
    const handleInputBlur = () => {
        if (!isMacOSSafariWebView) {
            react_native_1.Animated.timing(moveAnimation, {
                toValue: 0,
                duration: 300,
                useNativeDriver: true,
            }).start();
        }
    };
    return ((0, jsx_runtime_1.jsx)(react_native_1.Modal, { visible: isOpen, transparent: true, animationType: "slide", children: (0, jsx_runtime_1.jsx)(native_base_1.NativeBaseProvider, { children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.modalOverlay, children: (0, jsx_runtime_1.jsxs)(react_native_1.Animated.View, { style: [
                        styles.modalContent,
                        isWebDevice && styles.webContainer,
                        isMobileScreen && styles.mobileContainer,
                        { transform: [{ translateY: moveAnimation }] },
                    ], children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.header, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.headerText, children: modalTitle }), (0, jsx_runtime_1.jsx)(react_native_1.TouchableOpacity, { onPress: onClose, style: styles.closeButton, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faClose, color: colors_1.Colors.DARK_TEXT, size: 24 }) })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.inputContainer, children: (0, jsx_runtime_1.jsx)(react_native_1.TextInput, { style: styles.input, value: inputValue, onChangeText: setInputValue, onFocus: () => isMobileScreen && handleInputFocus(), onBlur: () => isMobileScreen && handleInputBlur(), placeholder: placeholderText, placeholderTextColor: colors_1.Colors.DARK_300 }) }), (0, jsx_runtime_1.jsx)(BigButton_1.default, { disabled: isSubmitDisabled, onPress: handleSubmit, style: [
                                styles.updateButton,
                                isSubmitDisabled && styles.disabledButton,
                            ], children: submitButtonText })] }) }) }) }));
};
const styles = react_native_1.StyleSheet.create({
    modalOverlay: {
        flex: 1,
        backgroundColor: `${colors_1.Colors.DARK_700}CC`,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalContent: {
        backgroundColor: colors_1.Colors.DARK_600,
        padding: 20,
        borderRadius: 16,
        width: '95%',
    },
    webContainer: {
        maxWidth: 500,
    },
    mobileContainer: {
        width: '95%',
        borderRadius: 16,
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20,
    },
    headerText: {
        color: colors_1.Colors.white,
        fontSize: 24,
        fontWeight: 'bold',
    },
    closeButton: {
        padding: 5,
    },
    inputContainer: {
        marginBottom: 20,
    },
    input: {
        backgroundColor: colors_1.Colors.DARK_700,
        borderWidth: 0,
        color: colors_1.Colors.white,
        padding: 12,
        borderRadius: 8,
        fontSize: 16,
    },
    updateButton: {
        borderRadius: 48,
        alignItems: 'center',
        paddingVertical: 15,
    },
    disabledButton: {
        opacity: 0.5,
    },
});
exports.default = GenericModal;
